import React from 'react';
import Lottie from 'react-lottie';
import { DEFAULT_ANIMATION_OPTIONS } from './constants';

export const AnimatedLoading = () => {
  return (
    <Lottie options={DEFAULT_ANIMATION_OPTIONS} width={500} height={300} />
  );
};
